import { z } from "zod/v3";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const certificationSchema = itemSchema.extend({
  name: z.string(),
  issuer: z.string(),
  date: z.string(),
  summary: z.string(),
  url: urlSchema,
});

// Type
export type Certification = z.infer<typeof certificationSchema>;

// Defaults
export const defaultCertification: Certification = {
  ...defaultItem,
  name: "",
  issuer: "",
  date: "",
  summary: "",
  url: defaultUrl,
};
